import { atom } from 'recoil';
import { getPrhBBRSelector } from '../selectors/getPrhBBRSelector';
import type {
    PrhHolidayHomeOnsaDTO,
    PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';

export const prhBBRAtom = atom<PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO>({
    key: 'prhBBRAtom',
    default: getPrhBBRSelector
});
